import { render, staticRenderFns } from "./sources.vue?vue&type=template&id=495641bb"
import script from "./sources.vue?vue&type=script&lang=js"
export * from "./sources.vue?vue&type=script&lang=js"
import style0 from "./sources.vue?vue&type=style&index=0&id=495641bb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports